import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { ApplicationData } from "../ApplicationData";
import { AvailabilityClientManager } from "../ClientManagers/AvailabilityClientManager";

export const CopiesTableRenderer = (function ($) {


	var separateBranchData = function (holdings, textualHoldings, collectionOfBranches) {
		var branchItem = {};
		var branchIds =  ApplicationData.branchLimitsUtil.getDisplayInCopiesIds();

		holdings = $.grep(holdings, function(result) {
			return ($.inArray(result.branchIdentifier, branchIds) != -1);
		});

		$.each(holdings, function (index, holding) {
			branchItem = getBranchItemFromHolding(holding, collectionOfBranches);
			branchItem.holdings.push(holding);
		});

		textualHoldings = $.grep(textualHoldings, function(result) {
			return ($.inArray(result.branchIdentifier, branchIds) != -1);
		});

		$.each(textualHoldings, function (index, holding) {
			branchItem = getBranchItemFromHolding(holding, collectionOfBranches);
			branchItem.textualHoldings.push(holding);
		});

		//now sort the branches into alpha order
		collectionOfBranches.sort(function (lhs, rhs) {
			if (lhs.branch.toLowerCase() > rhs.branch.toLowerCase()) {
				return 1;
			} else if (lhs.branch.toLowerCase() < rhs.branch.toLowerCase()) {
				return -1;
			}
			return 0;
		});

	};

	var sortHoldings = function(holdings) {
		// sort descending by chronology+enumeration
		holdings.sort(function (lhs, rhs) {
			var leftSort = lhs.chronologySort + lhs.enumerationSort;
			var rightSort = rhs.chronologySort + rhs.enumerationSort;
			if (leftSort < rightSort) {
				return 1;
			} else if (leftSort > rightSort) {
				return -1;
			}
			return 0;
		});
	};

	var getBranchItemFromHolding = function(holding, collectionOfBranches) {
		for (var x = 0; x < collectionOfBranches.length; x++) {
			if (collectionOfBranches[x].branch === holding.branchName) {
				return collectionOfBranches[x];
			}
		}

		var branchItem = {};
		branchItem.branch = holding.branchName;
		branchItem.tableID = "copiesTable_"+holding.branchIdentifier;
		branchItem.holdings = [];
		branchItem.textualHoldings = [];
		branchItem.callout = "";
		branchItem.showLink = false;
		collectionOfBranches.push(branchItem);
		return branchItem;
	};

	var nonSerialExt;
	var getNonSerialExt = function () {
		// NOTE:
		// {resourceUtil.getAvailabilityLink} should not matter since the conditions will not be met but the unique url will be
		// this will resolve the WAVE redundant link issue
		if (!nonSerialExt) {
			nonSerialExt = TLCEXT.Template('<div class="dataTable nonSerialDataTable {callout} {resourceUtil.getHasMap}" id="{tableID}">' +
				'<h3>{languageUtil.findOnShelf} {languageUtil.availability_at} {branch} <span {resourceUtil.showAvailabilityLinkInTmpl}>(<a {resourceUtil.getAvailabilityLink} class="allCopies">{languageUtil.availability_checkOtherLocations}</a>)</span></h3>' +
				'<table><thead><th>{languageUtil.collection}</th><th>{languageUtil.shelfLocation}</th><th>{languageUtil.status}</th><th {resourceUtil.hideIfNoMap}>{languageUtil.map}</th></thead>' +
				'<tbody>#~holdings#<tr class="{resourceUtil.oddOrEven}"><td>##collectionName##</td><td>{resourceUtil.getCallNumberForHolding} {resourceUtil.getVolumeAndCopyForHolding} {resourceUtil.getPartsInfo}</td><td class="{resourceUtil.getStatusClassForCopiesTable}">##status##{resourceUtil.getDueDate}</td>{resourceUtil.getMapButtonForCopiesTable}</tr>#/~#' +
				'<tr {resourceUtil.showHoldingsTruncatedInTmpl}><td colspan="3">(<a {resourceUtil.getAvailabilityLink} class="allCopies">{languageUtil.viewAllCopies}</a>)</td></tr>' +
				'</tbody></table>' +
				'</div>');
		}
		return nonSerialExt;
	};

	var serialExt;
	var getSerialExt = function () {
		// NOTE:
		// {resourceUtil.getAvailabilityLink} should not matter since the conditions will not be met but the unique url will be
		// this will resolve the WAVE redundant link issue
		if (!serialExt) {
			serialExt = TLCEXT.Template('<div class="dataTable serialDataTable {callout} {resourceUtil.getHasMap}" id="{tableID}">' +
				'<h3>{languageUtil.findOnShelf} {languageUtil.availability_at} {branch} <span {resourceUtil.showAvailabilityLinkInTmpl}>(<a {resourceUtil.getAvailabilityLink} class="allCopies">{languageUtil.availability_checkOtherLocations}</a>)</span></h3>' +
				'<table {resourceUtil.hideIfNoTextualHoldings}><thead><th>{languageUtil.holdingStatement}</th><th>{languageUtil.publicNote}</th></thead>' +
				'<tbody>#~textualHoldings#<tr class="{resourceUtil.oddOrEven}"><td>##textualHoldingStatement##</td><td>##publicNote##</td></tr>#/~#' +
				'<tr {resourceUtil.showTextualHoldingsTruncatedInTmpl}><td colspan="2">(<a {resourceUtil.getAvailabilityLink} class="allCopies">{languageUtil.viewAllCopies}</a>)</td></tr>' +
				'</tbody></table>' +
				'<table {resourceUtil.hideIfNoHoldings}><thead><th>{languageUtil.collection}</th><th>{languageUtil.serialInfo}</th><th>{languageUtil.status}</th><th {resourceUtil.hideIfNoMap}>{languageUtil.map}</th></thead>' +
				'<tbody>#~holdings#<tr class="{resourceUtil.oddOrEven}"><td>##collectionName##</td><td>{resourceUtil.getSerialsInfoForHolding}</td><td class="{resourceUtil.getStatusClassForCopiesTable}">##status##{resourceUtil.getDueDate}</td>{resourceUtil.getMapButtonForCopiesTable}</tr>#/~#' +
				'<tr {resourceUtil.showHoldingsTruncatedInTmpl}><td colspan="3">(<a {resourceUtil.getAvailabilityLink} class="allCopies">{languageUtil.viewAllCopies}</a>)</td></tr>' +
				'</tbody></table>' +
				'</div>');
		}
		return serialExt;
	};

	var printByBranch = function (domElementToAppendTo, appendMethod, collectionOfBranches, resource, callback) {
		if (collectionOfBranches.length > 0) {
			var branch = collectionOfBranches.shift();
			AvailabilityClientManager.getItemAvailabilityByHoldings((resource.holdingsInformations.length > 300) ? branch.holdings : resource.holdingsInformations, resource.id, function (resources, wentToServer, success) {
				if (resource.serial) {
					getSerialExt()[appendMethod](domElementToAppendTo, branch);
				} else {
					getNonSerialExt()[appendMethod](domElementToAppendTo, branch);
				}

				printByBranch(domElementToAppendTo, appendMethod, collectionOfBranches, resource);

				if (callback && collectionOfBranches.length == 0) {
					callback();
				}
			}, false, false);
		}
	};

	return {
		prepend:function (domElementToAppendTo, resource, calloutLocal, onlyRenderCurrentLocationHoldings, callback) {
			CopiesTableRenderer.render(domElementToAppendTo, "prepend", resource, calloutLocal, onlyRenderCurrentLocationHoldings, callback);
		},
		append: function (domElementToAppendTo, resource, calloutLocal, onlyRenderCurrentLocationHoldings, callback) {
			CopiesTableRenderer.render(domElementToAppendTo, "append", resource, calloutLocal, onlyRenderCurrentLocationHoldings, callback);
		},
		render: function (domElementToAppendTo, appendMethod, resource, calloutLocal, onlyRenderCurrentLocationHoldings, callback) {
			appendMethod = appendMethod || "append";

			calloutLocal = (calloutLocal != undefined) ? calloutLocal : true;
			onlyRenderCurrentLocationHoldings = (onlyRenderCurrentLocationHoldings != undefined) ? onlyRenderCurrentLocationHoldings : false;

			var branchToUse = ApplicationData.getBranchToUseForAvailability(),
				allHoldings = resource.holdingsInformations ? resource.holdingsInformations.slice(0) : [],
				allTextualHoldings = resource.textualHoldings ? resource.textualHoldings.slice(0) : [],
				otherHoldings = [],
				otherTextualHoldings = [],
				collectionOfBranches = [];

			if (appendMethod != "prepend") {
				domElementToAppendTo.empty();
			}

			if (allHoldings.length == 0 && allTextualHoldings.length == 0 && !onlyRenderCurrentLocationHoldings) {
				if (resource.downloadable) {
					domElementToAppendTo.append("<p>" + ApplicationData.language.downloadableResourceMessage + "</p>");
				} else {
					domElementToAppendTo.append("<p>" + ApplicationData.language.noCopies + "</p>");
				}
				if (callback) {
					callback();
				}
			} else {
				sortHoldings(allHoldings);
				if (calloutLocal) {
					var localHoldings = $.grep(allHoldings, function (holding) {
						if (holding.branchIdentifier != branchToUse) {
							otherHoldings.push(holding);
						}
						return (holding.branchIdentifier == branchToUse);
					});

					var localTextualHoldings = $.grep(allTextualHoldings, function (holding) {
						if (holding.branchIdentifier != branchToUse) {
							otherTextualHoldings.push(holding);
						}
						return (holding.branchIdentifier == branchToUse);
					});

					var localItem = null;
					if (localHoldings.length > 0) {
						localItem = localHoldings[0];
					} else if (localTextualHoldings.length > 0) {
						localItem = localTextualHoldings[0];
					}

					if (localItem !== null) {
						var showLink = onlyRenderCurrentLocationHoldings;
						if (showLink) {
							if (ApplicationData.locationConfiguration.isDisplayCopiesFirst()) {
								collectionOfBranches.push({
									branch:  localItem.branchName,
									tableID: "copiesTable_"+localItem.branchIdentifier,
									holdings: (localHoldings ? localHoldings.slice(0,5) : null),
									textualHoldings: (localTextualHoldings ? localTextualHoldings.slice(0,5) : null),
									callout: 'callout',
									showLink:(otherHoldings.length > 0),
									holdingsTruncated:(localHoldings.length > 5),
									textHoldingsTruncated:(localTextualHoldings.length > 5)
								});
							} else {
								collectionOfBranches.push({
									branch:  localItem.branchName,
									tableID: "copiesTable_"+localItem.branchIdentifier,
									holdings: localHoldings,
									textualHoldings: localTextualHoldings,
									callout: 'callout',
									showLink:(otherHoldings.length > 0),
									holdingsTruncated: false,
									textHoldingsTruncated: false
								});
							}
						} else {
							collectionOfBranches.push({
								branch:  localItem.branchName,
								tableID: "copiesTable_"+localItem.branchIdentifier,
								holdings: localHoldings,
								textualHoldings: localTextualHoldings,
								callout: 'callout',
								showLink: false,
								holdingsTruncated: false,
								textHoldingsTruncated: false
							});
						}
					}

					printByBranch(domElementToAppendTo, appendMethod, collectionOfBranches, resource, callback);

					if (onlyRenderCurrentLocationHoldings == false) {
						separateBranchData(otherHoldings, otherTextualHoldings, collectionOfBranches);
					}

				} else {
					separateBranchData(allHoldings, allTextualHoldings, collectionOfBranches);
				}

				printByBranch(domElementToAppendTo, appendMethod, collectionOfBranches, resource, callback);
			}


		}
	};

})(jQuery);
